import * as UI from "@iyk/ui"

export const HeaderLogo = ({ align = "center" }: { align?: "center" | "left" }) => (
  <h1 className={classForHeaderLogo({ align })}>[Daniel Allan]</h1>
)

const classForHeaderLogo = UI.cva(
  "text-gray-12 font-departure-mono text-[11px] tracking-[0.8px] uppercase leading-4",
  {
    variants: {
      align: {
        center: "text-center",
        left: "text-left",
      },
    },
  },
)
